import { axios } from './axios';
import { handleErrors } from './utils';

export function initIframe(payload) {
    return new Promise((resolve, reject) => {
        axios
            .post(`external/v1/forms`, payload)
            .then(({ data }) => {
                resolve(data);
            })
            .catch(handleErrors(reject));
    });
}
